import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import styles from './BoxContainer.module.scss';
import cx from 'classnames';

function BoxContainer(props) {
  return (
    <Row className={props.className}>
      <Col
        xs={{ span: props.xsColSize, offset: props.xsColOffset }}
        sm={{ span: props.smColSize, offset: props.smColOffset }}
        lg={{ span: props.lgColSize, offset: props.lgColOffset }}
      >
        <Row
          className={cx(styles.container, styles[props.theme], 'p-4 p-md-5')}
        >
          {props.title && (
            <Col xs={12}>
              <h1 className={`text-dark text-center ${props.titleClassName}`}>
                {props.title}
              </h1>
            </Col>
          )}
          {props.children && <Col xs={12}>{props.children}</Col>}
        </Row>
      </Col>
    </Row>
  );
}

BoxContainer.propTypes = {
  xsColSize: PropTypes.number,
  xsColOffset: PropTypes.number,
  smColSize: PropTypes.number,
  smColOffset: PropTypes.number,
  lgColSize: PropTypes.number,
  lgColOffset: PropTypes.number,
  spacing: PropTypes.bool,
  title: PropTypes.string,
  titleClassName: PropTypes.string,
  theme: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default BoxContainer;
